import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pxEditPanel-mainContainer" }
const _hoisted_2 = { class: "pxEditPanel-content" }
const _hoisted_3 = { class: "pxEditPanel-title" }
const _hoisted_4 = { class: "pxEditPanel-normalPane" }
const _hoisted_5 = { class: "pxEditPanel-editPane" }
const _hoisted_6 = { class: "pxEditPanel-actions" }
const _hoisted_7 = {
  key: 0,
  class: "pxEditPanel-footer"
}
const _hoisted_8 = { class: "pxEditPanel-footerNotice" }
const _hoisted_9 = { class: "pxEditPanel-footerButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxButton = _resolveComponent("PxButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'is-editing': _ctx.isEditing }, "pxEditPanel"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "normal", {}, undefined, true)
        ], 512), [
          [_vShow, !_ctx.isEditing || _ctx.isRedirecting]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "edit", {}, undefined, true)
        ], 512), [
          [_vShow, _ctx.isEditing]
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createVNode(_component_PxButton, {
          class: "pxEditPanel-editBtn",
          size: "small",
          onClick: _ctx.onClickStartEdit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("common.edit")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ], 512), [
        [_vShow, !_ctx.isEditing || _ctx.isRedirecting]
      ])
    ]),
    (_ctx.isEditing && !_ctx.isRedirecting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[0] || (_cache[0] = _createElementVNode("i", null, null, -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("common.notices.changeProfile")), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_PxButton, {
              class: "pxEditPanel-cancelBtn",
              type: "link",
              onClick: _ctx.onClickCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("common.cancel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_PxButton, {
              disabled: _ctx.isSaveButtonDisabled,
              loading: _ctx.isLoading,
              class: "pxEditPanel-saveBtn",
              type: "green",
              onClick: _ctx.onClickSave
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("common.save")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading", "onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}